import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Container, Nav, Tab, Tabs } from "react-bootstrap";
import AlertComponent from "../../../components/AlertComponent/AlertBox";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import EditIcon from "../../../assets/images/Icons/pencilIcon.svg";
import UploadIcon from "../../../assets/images/uploadIcon.svg";
import deleteIcon from "../../../assets/images/Icons/deleteIcon.svg";
import { SettingsRoleContext } from "../SettingsRoleView";
import { baseURL } from "../../../api/Axios";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { Spinner } from "react-bootstrap";
import "./settingsRole.css";

const SettingsRole = ({ textContent }) => {
  const {
    navigateToPermissions,
    navigateToSettings,
    navigateToRoleManagement,
    mainRole,
    roleDetails,
    spinnerStatus,
    roleDetailByState,
    deleteAssignRole,
    setAlert,
    getReassignList,
    responseMessage,
    alert,
    setIsEdit,
    assignRole,
    statusCode,
    goBack,
    logout,
    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardFileDownload,
    cardExcel,
    handleAlertSubmit,
  } = useContext(SettingsRoleContext);
  const changeToSettings = (tab) => {
    tab === "device-settings" && navigateToSettings();
    tab === "permissions" && navigateToPermissions();
  
  };
  const roleDetailer = [
    { title: "Name", prop: "EmployeeName" },
    {
      prop: "",

      cell: (row) => (
        <div className="d-flex justify-content-end">
          <img
            className="settings-edit-button mx-4"
            src={EditIcon}
            alt="Edit icon"
            onClick={() => {
              assignRole(
                roleDetailByState?.RoleId,
                roleDetailByState?.RoleName,
                true,
                row
              );
              setIsEdit(true);
            }}
          />
          <img
            className="settings-delete-button"
            src={deleteIcon}
            alt="Delete icon"
            onClick={() => {
              deleteAssignRole(row?.EmployeeId);
            }}
          />
        </div>
      ),
    },
  ];
  useEffect(() => {
    getReassignList();
  }, []);

  return (
    <div className="settings">
      <Topbar />
      <Container className="my-4">
        <Tabs
          onSelect={(e) => {
            changeToSettings(e);
          }}
          defaultActiveKey="permissions"
          id="uncontrolled-tab-example"
        >
          <Tab
            eventKey="permissions"
            title={textContent.permissions.toUpperCase()}
          >
            <div className=" heading-row my-3">
              <div className="title-box">
                <img
                  onClick={navigateToRoleManagement}
                  id="arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={22}
                />
                <p className="title-name titleSetting">
                  {roleDetailByState?.RoleName}
                </p>
              </div>
              <Button
                customClass={"settings-add-new-role-inner"}
                onClick={() => {
                  assignRole(
                    roleDetailByState?.RoleId,
                    roleDetailByState?.RoleName
                  );
                }}
                text={textContent.add}
              />
            </div>
            <div className="roleManagement">
              <DataTable
                tableData={roleDetails}
                header={roleDetailer}
                isPagination={false}
              />
            </div>
          </Tab>
          <Tab eventKey="visitor-card" title="VISITORS CARD">
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  className="back-arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={17}
                  onClick={() => goBack()}
                />
                <p className="title-name">{textContent.magneticTitle}</p>
              </div>
              <p className={"download-text"}>
                <a
                  className={"excel-download"}
                  href={
                    cardFileDownload
                      ? `${baseURL}/excel/${cardFileDownload}`
                      : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  Download Visitors Card
                </a>
              </p>
            </div>
            <form onSubmit={visitorCardSubmit} className="uploadCradSection">
              <div className="uploadMagneticCardData">
                <label className="uploadPhotoContainerGuest">
                  <img src={UploadIcon} alt="img" />
                  <span className="uploadTextRegister">
                    {cardExcel ? cardExcel : "UPLOAD"}
                  </span>
                  <input
                    className="input-group-text"
                    type={"file"}
                    onChange={handleMagneticUpload}
                  />
                </label>
                <p className="mb-0 error-msg">
                  {fileErrorMessage ? fileErrorMessage : ""}
                </p>
              </div>
              <div className="fileSubmitBtns">
                <button type="submit" className="button">
                  {spinnerStatus ? <Spinner size="sm" /> : "Submit"}
                </button>
              </div>
            </form>
          </Tab>

          <Tab
            eventKey="device-settings"
            title={textContent.deviceSettings.toUpperCase()}
          >
            <div className="heading-row my-3">
              <div className="title-box">
                <img id="arrow" src={BackArrow} alt="Back Arrow" width={22} />
                <p className="title-name">{textContent.deviceSettings}</p>
              </div>
            </div>
          </Tab>
        </Tabs>
        {alert && (
          <AlertComponent
            show={alert}
            setShow={setAlert}
            alertMessage={responseMessage}
            handleSubmit={
              statusCode == 401
                ? () => logout()
                : () => {
                    handleAlertSubmit();
                    getReassignList();
                    navigateToRoleManagement();
                  }
            }
          />
        )}
      </Container>
    </div>
  );
};

export default SettingsRole;
